import { render, staticRenderFns } from "./orderTiktok.vue?vue&type=template&id=8a653656&scoped=true"
import script from "./orderTiktok.vue?vue&type=script&lang=js"
export * from "./orderTiktok.vue?vue&type=script&lang=js"
import style0 from "./orderTiktok.vue?vue&type=style&index=0&id=8a653656&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a653656",
  null
  
)

export default component.exports